import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import { BarChart3 } from 'lucide-react';
import { resetPassword } from '../utils/api';

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error('Password must be at least 6 characters'); return; }
    if (password !== confirm) { toast.error('Passwords do not match'); return; }
    setLoading(true);
    try {
      await resetPassword(token, password);
      toast.success('Password reset — you can now log in.');
      navigate('/login');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Failed to reset password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #0F172A 0%, #1E293B 50%, #0F172A 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div style={{ width: '100%', maxWidth: 420 }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ width: 52, height: 52, background: 'linear-gradient(135deg,#3B82F6,#8B5CF6)', borderRadius: 14, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px' }}>
            <BarChart3 size={24} color="#fff" />
          </div>
          <h1 style={{ color: '#fff', fontSize: 24, fontWeight: 800 }}>Unbrand</h1>
        </div>

        <div style={{ background: '#fff', borderRadius: 16, padding: '32px 36px', boxShadow: '0 25px 50px rgba(0,0,0,.4)' }}>
          <h2 style={{ fontSize: 18, fontWeight: 700, marginBottom: 4 }}>Set a new password</h2>

          {!token ? (
            <p style={{ color: 'var(--text2)', fontSize: 13, marginTop: 16 }}>
              This link is missing a reset token. Request a new one from the{' '}
              <Link to="/forgot-password" style={{ color: 'var(--primary)', fontWeight: 600 }}>forgot password</Link> page.
            </p>
          ) : (
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16, marginTop: 20 }}>
              <div className="form-group">
                <label className="form-label">New Password</label>
                <input className="form-input" type="password" placeholder="At least 6 characters"
                  value={password} onChange={e => setPassword(e.target.value)} required />
              </div>
              <div className="form-group">
                <label className="form-label">Confirm Password</label>
                <input className="form-input" type="password" placeholder="Repeat password"
                  value={confirm} onChange={e => setConfirm(e.target.value)} required />
              </div>
              <button type="submit" disabled={loading} className="btn btn-primary btn-lg" style={{ justifyContent: 'center' }}>
                {loading ? 'Saving...' : 'Reset password'}
              </button>
            </form>
          )}

          <div style={{ textAlign: 'center', marginTop: 20, fontSize: 13, color: 'var(--text2)' }}>
            <Link to="/login" style={{ color: 'var(--primary)', fontWeight: 600 }}>Back to login</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
